//
import GBranchOfficeModel from '@/models/General/GBranchOffice'

//
export default [
  {
    name: "g_branch_office_id",
    type: "autocomplete-model",
    props: {
      itemText: "name",
      itemValue: "id",
      noObject: true,
      label: "Sucursal",
      model: GBranchOfficeModel,
      paramSearch: "name",
    }
  },
  {
    name: "number",
    type: "text-field",
    props: {
      hideDetails: true,
      label: "Numero",
    }
  },
  {
    name: "name",
    type: "text-field",
    props: {
      hideDetails: true,
      label: "Nombre",
    }
  },
]

// g_branch_office_id
// number
// name